'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';

const HASH_PATH_PREFIX = '#/';

export default function HashRedirect() {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const { hash, search } = window.location;

    if (!hash.startsWith(HASH_PATH_PREFIX)) {
      return;
    }

    const targetPath = hash.slice(1);

    if (!targetPath || targetPath === pathname + search) {
      window.history.replaceState(null, '', `${pathname}${search}`);
      return;
    }

    try {
      router.replace(`${targetPath}${search}`);
    } catch (error) {
      window.location.replace(`${targetPath}${search}`);
    }
  }, [pathname, router]);

  return null;
}

